// extracted by mini-css-extract-plugin
export default {"feedbackButton":"f7fn5WjJw1ZAyvlWhMM4"};